
import { defineComponent, computed, PropType } from 'vue'
import { useRoute } from 'vue-router'
import { transformEmoji } from '@/views/stocknotes/transform'
import {
  getCaseStockInfo,
  getCircleMessagePreview,
  isCaseStockMessage,
  isImageMessageType,
  isLinkUrlMessageType,
  isTextMessageType,
  isVoiceMessageType,
  openStarJfztUrl,
} from '@/utils/starZoneHelper'

export default defineComponent({
  name: 'StarCircleMessage',
  props: {
    message: {
      type: Object as PropType<Record<string, any>>,
      required: true,
    },
  },
  setup(props) {
    const route = useRoute()
    const messageType = computed(() => props.message?.messageType || '')

    const isTextMessage = computed(() => isTextMessageType(messageType.value))
    const isCaseStock = computed(() => isCaseStockMessage(messageType.value))
    const isImageMessage = computed(() => isImageMessageType(messageType.value))
    const isVoiceMessage = computed(() => isVoiceMessageType(messageType.value))
    const isLinkUrlMessage = computed(() => isLinkUrlMessageType(messageType.value))

    const caseStockInfo = computed(() => getCaseStockInfo(props.message?.message))
    const previewText = computed(() => getCircleMessagePreview(props.message))
    const linkUrlInfo = computed(() => {
      const data = getCircleMessagePreview(props.message, true) as { text: string; url: string }
      return data
    })

    const renderTextMessage = (text?: string) => {
      if (!text) return ''
      return transformEmoji(text)
    }

    const openLink = (url: string) => {
      if (url) openStarJfztUrl(url, route.query as Record<string, unknown>)
    }

    return {
      isTextMessage,
      isCaseStock,
      isImageMessage,
      isVoiceMessage,
      isLinkUrlMessage,
      caseStockInfo,
      previewText,
      linkUrlInfo,
      renderTextMessage,
      openLink,
    }
  },
})
